import { useCreateUrlWithQuery } from '../../hooks/useQuery';
import request from '../request';

export const getRego = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/setting/getRego', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
export const deviceHealthCheck = ({ userId, orgId, regoId }) =>
  request.base.get(
    'v2/setting/regoHealthCheck',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
        'rego-id': regoId,
      },
    },
  );

export const deleteRego = ({ userId, orgId, list }) =>
  request.base.delete(
    `v2/setting/deleteRego/${list}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateRego = ({ userId, orgId, item }) =>
  request.base.post('v2/setting/updateRego', item, {
    headers: {
      'user-id': userId,
      'org-id': orgId,
    },
  });

export const activateDevice = ({ userId, orgId, dva, ndisRego }) =>
  request.base.post(
    'v2/setting/device/activation',
    { dva, ndisRego },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const addNewRego = ({ userId, orgId, item }) =>
  request.base.put('v2/setting/addRego', item, {
    headers: {
      'user-id': userId,
      'org-id': orgId,
    },
  });

export const issueApiKey = ({ userId, orgId }) =>
  request.base.put(
    'v2/setting/issueApiKey',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getNdisCatalogue = () =>
  request.base.get('v2/setting/getNdisCatalogue', {}, { headers: {} });

export const getFinanceSoftware = ({ userId, orgId }) =>
  request.base.get(
    'v2/setting/financeIntegration',
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateFinanceSoftware = ({ userId, orgId, softwareName }) =>
  request.base.post(
    'v2/setting/financeIntegration',
    { softwareName },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getProduct = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/setting/product', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateProduct = ({ userId, orgId, item }) =>
  request.base.post(
    'v2/setting/product',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
export const addProduct = ({ userId, orgId, item }) =>
  request.base.put(
    'v2/setting/product',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteProduct = ({ userId, orgId, list }) =>
  request.base.delete(
    `v2/setting/product/${list}`,
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getCategories = ({ userId, orgId, categoryType, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery(`in-out-extended/v2/categories`, { ...parameters, categoryType }),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateCategory = ({ userId, orgId, item }) =>
  request.base.post(
    'in-out-extended/v2/updateCategory',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const deleteCategory = ({ userId, orgId, list, categoryType }) =>
  request.base.post(
    'in-out-extended/v2/deleteCategory',
    {
      categoryIds: list,
      categoryType: categoryType.toUpperCase(),
    },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const addCategory = ({ userId, orgId, item, categoryType }) =>
  request.base.put(
    'in-out-extended/v2/addCategory',
    { ...item, categoryType },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getLabels = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/setting/label', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getDeliverySetting = ({ userId, orgId, parameters }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/setting/delivery', parameters),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const updateLabels = ({ userId, orgId, item }) =>
  request.base.post(
    'v2/setting/label',
    { ...item },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const getGeneralSettingByKey = ({ userId, orgId, settingName }) =>
  request.base.get(
    useCreateUrlWithQuery('v2/setting/general-settings', { settingName }),
    {},
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );

export const upsertGeneralSettingByKey = ({ userId, orgId, settingName, settingValue }) =>
  request.base.post(
    'v2/setting/general-settings',
    { settingName, settingValue },
    {
      headers: {
        'user-id': userId,
        'org-id': orgId,
      },
    },
  );
